<template>
  <div>
     <vue-header/>
     <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="true">
          </loading>
    <div class="wd-container" style="margin-top: 15px;text-align:left;background-color: #F3F3F3;">
    <div class="container" style="background-color:#F3F3F3">
       <div class="d-flex justify-content-between align-items-center mb-3">
         <router-link :to="'/'+previousUrl" tag="button">
           <i class="fa fa-arrow-circle-left" style="font-size:25px;cursor:pointer;" ></i>
         </router-link>
         <div class="d-flex justify-content-between align-items-center" style="gap:4px;">
          <button class="btn btn-primary" @click="showActivitiesModal" style="margin-left: auto;">
            <i class="fa fa-list-alt" style="margin-right: 5px;"></i>Activities & Notes
          </button>
          <button class="btn btn-primary" @click="openBidInvoiceModal" style="margin-left: auto;">
            <i class="fa fa-dollar" style="margin-right: 5px;"></i>Bid/Invoice
          </button>
        </div>
       </div>
          <div class="card">
            <div class="card-header bg-dark text-white" style="text-align:center;">
              <h1 style="font-size:18px;">Edit Job - {{jobData.name}}</h1>
            </div>
          </div>
          <!---------------------------------- Job INfo ------------------------------------------------>
          <b-card  header="Job Info">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Job Name<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.name"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Job Number<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.job_number"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Account<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <vue-bootstrap-typeahead
                    :minMatchingChars = 1
                    class="shadow-sm"
                    placeholder="Search Account"
                    :maxMatches = 100
                    ref="account"
                    v-model="jobData.account"
                    :serializer="item => item.value"
                    :data="account_options"
                    @hit="selectedAccount($event)"
                    />
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Current Status<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.status" :options="status_options" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Bid Date<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.bid_date" format="MM/dd/yyyy"></datetime>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Primary Contact<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <vue-bootstrap-typeahead
                    :minMatchingChars = 1
                    class="shadow-sm"
                    placeholder="Search Contact"
                    :maxMatches = 100
                    ref="contact"
                    v-model="jobData.primary_contact"
                    :serializer="item => item.value"
                    :data="job_contacts_dropdown"
                    @hit="selectedContact($event)"
                    />
                  </b-col>
                  <b-col sm="12">
                    <b-button  class="btn btn-contact mt-2 float-right" @click="selectContactModal">
                    View Contacts
                    </b-button>
                  </b-col>
                </b-row>
          </b-card>



          <!---------------------------------- Address ------------------------------------------------>


          <b-card  header="Addresses">
            <b-row class="my-1">
                  <b-col sm="12">
                    <label for="input-default"  class="mb-2 mt-2"><b>Site Address</b><i class="material-icons" v-if="!jobData.site_longitude" style="font-size: 18px;margin-left: 15px;position: absolute;color:#E9A651;margin-top: 5px;" title="Site address is not valid">not_listed_location</i></label>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_address_1"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address 2<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_address_2"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">City<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_city"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">State<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.site_state" :options="contactStates" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Zip<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_zip"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="12" class="mt-2" v-if="jobData.site_address_1 || jobData.site_address_2 || jobData.site_city || jobData.site_state || jobData.site_zip">
                    <button @click="openInMaps('site')" class="btn btn-secondary">
                      <i class="fa fa-map-marker" style="margin-right: 5px;"></i>Open in Maps
                    </button>
                  </b-col>
                  <b-col sm="12" class="mb-2 mt-2">
                    <label for="input-default"><b>Billing Address</b></label>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_address_1"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address 2<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_address_2"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">City<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_city"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">State<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">

                    <b-form-select class="shadow-sm mb-1" v-model="jobData.billing_state" :options="contactStates" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Zip<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_zip"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="12" class="mt-2" v-if="jobData.billing_address_1 || jobData.billing_address_2 || jobData.billing_city || jobData.billing_state || jobData.billing_zip">
                    <button @click="openInMaps('billing')" class="btn btn-secondary">
                      <i class="fa fa-map-marker" style="margin-right: 5px;"></i>Open in Maps
                    </button>
                  </b-col>
                </b-row>
          </b-card>


          <!---------------------------------- Project Roles ------------------------------------------------>


          <b-card  header="Project Roles">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Estimator<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.estimator" style="color: black;">
                      <option v-for="(val, indexOpt) in estimator_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Project Manager<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.project_manager"  style="color: black;">
                      <option v-for="(val, indexOpt) in project_manager_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Foreman<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.foreman"  style="color: black;">
                      <option v-for="(val, indexOpt) in foreman_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Accountant<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.accounting" style="color: black;">
                      <option v-for="(val, indexOpt) in accountant_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Salesperson<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.salesman"  style="color: black;">
                       <option v-for="(val, indexOpt) in sales_person_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Job Charecteristics ------------------------------------------------>


          <b-card  header="Job Characteristics">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Lead Source<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.lead_source" style="color: black;">
                        <option v-for="(val, indexOpt) in lead_source_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Prevailing Wage Survey<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.prevailing_wage" style="color: black;">
                        <option v-for="(val, indexOpt) in prevailingWages"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown1}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_1"  style="color: black;">
                      <option v-for="(val, indexOpt) in custom_drop_options_1"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown2}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_2"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_2"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown3}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_3"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_3"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown4}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_4"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_4"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown5}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_5"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_5"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown6}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_6"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_6"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField1}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_1"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField2}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_2"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField3}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_3"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField4}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_4"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField5}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_5"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField6}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_6"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Dates and Priorities ------------------------------------------------>


          <b-card  header="Dates and Priorities">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Estimator Deadline<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.estimator_deadline" format="MM/dd/yyyy"></datetime>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Estimator Priority<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.estimator_priority" :options="['Low', 'Medium', 'High']" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Production Deadline<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.production_deadline" format="MM/dd/yyyy"></datetime>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Production Priority<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.production_priority" :options="['Low', 'Medium', 'High']" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Work Completed<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.completed_date" format="MM/dd/yyyy"></datetime>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Progression Tracker ------------------------------------------------>


          <b-card  header="Progression Tracker">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Select Stage<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                     <b-form-select class="shadow-sm mb-1" v-model="jobData.progress_status" :options="progressionOptions" style="color: black;" @change="checkStatus"></b-form-select>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Production Tracker ------------------------------------------------>

          <b-card v-if="progression_flag" header="Production Tracker">
            <b-row class="my-1">
                  <b-col sm="12">
                    <h5>Scope</h5>
                  </b-col>
                  <b-col sm="12">
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th width="40">
                              <input type="checkbox" @change="selectAllRows" v-model="selectAll">
                            </th>
                            <th>Description</th>
                            <th>Units</th>
                            <th width="120">Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in progressionValuesData" :key="index">
                            <td>
                              <input type="checkbox" v-model="row.selected">
                            </td>
                            <td>
                              <b-form-select v-model="row.discipline" class="form-control" style="color: black;" @change="onDisciplineChange(row)">
                                <option value="">Select Description</option>
                                <option v-for="option in progressionFieldOptions" :key="option.id" :value="option.id">
                                  {{ option.value }}
                                </option>
                              </b-form-select>
                            </td>
                            <td>
                              <b-form-input v-model="row.unit" class="form-control" placeholder="Enter units" :readonly="row.discipline"></b-form-input>
                            </td>
                            <td>
                              <b-form-input v-model="row.quantity" type="number" step="0.01" class="form-control" placeholder="0.00"></b-form-input>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-col>
                  <b-col sm="12">
                    <button type="button" class="btn btn-secondary mr-2" @click="addSelectedRow">Add Row</button>
                    <button type="button" class="btn btn-outline-secondary" @click="deleteSelectedRow">Delete Selected</button>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Prime Contract ------------------------------------------------>


          <b-card  header="Prime Contract">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Enter Prime Contract<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.prime_contract"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Bid Tracker ------------------------------------------------>

          <b-card  header="Bid Tracker">
            <b-row class="my-1">
                  <b-col sm="12">
                    <div class="form-check form-check-inline">
                      <b-form-checkbox
                        v-model="jobData.bid_status"
                        :value="1"
                        :unchecked-value="0"
                        class="mb-2">
                        Add to Bid Tracker?
                      </b-form-checkbox>
                    </div>
                  </b-col>
                  <template v-if="jobData.bid_status">
                    <b-col sm="2">
                      <label for="input-default">Select Type<span style="color:red;"></span></label>
                    </b-col>
                    <b-col sm="4">
                      <b-form-select class="shadow-sm mb-1" v-model="jobData.bid_type" style="color: black;">
                        <option value="">Select Type</option>
                        <option v-for="(val, indexOpt) in bid_type_options"
                              :key="val.id"
                              v-bind:value="val.id"
                          >
                              {{ val.bid_type }}
                          </option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="2">
                      <label for="input-default">Select Stage<span style="color:red;"></span></label>
                    </b-col>
                    <b-col sm="4">
                      <b-form-select class="shadow-sm mb-1" v-model="jobData.bid_stage" style="color: black;">
                        <option value="">Select Stage</option>
                        <option v-for="(val, indexOpt) in bid_stage_options"
                              :key="val.id"
                              v-bind:value="val.id"
                          >
                              {{ val.bid_stage }}
                          </option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="2">
                      <label for="input-default">Note<span style="color:red;"></span></label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-textarea
                        id="input-default"
                        class="shadow-sm p-3 mb-1 bg-white rounded"
                        v-model="jobData.bid_notes"
                        rows="3"
                        placeholder="Enter bid notes..."
                        ></b-form-textarea>
                    </b-col>
                  </template>
                </b-row>
          </b-card>
          <div class="clearfix"></div>
          <b-card >
          <div class="form-group" style="text-align: center;margin-top:8px;margin-bottom:15px;">
          <button type="submit" class="btn btn-save shadow" @click="updateJob"> Save  </button>
          </div>
          </b-card>
        <!-- Modal for contact -->
          <b-modal ref="my-modal-select"  title="Using Component Methods">
            <template v-slot:modal-header="{  }">

             <div class="row" style="width: 100%;">
              <div class="col-12">
                <div >
                  <i class="material-icons float-left" style="font-size: 42px;margin-right: 8px;color: #303032;">
                    perm_contact_calendar
                  </i>
                </div>
                <div class="wd-modal-subheader">
                  <h3 style="font-size: 18px;font-weight: 300;color: #303032;margin: 0;">Current Contacts on Job</h3>
                </div>
              </div>
            </div>
            </template>
            <div class="wd-modal-body p-l-20 p-r-20">
              <div class="row">
                <div class="col-sm-12">
                      
                    <table id="past_table" class="display responsive nowrap">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in contacts" :key="item.id">
                          <td>{{item.first_name+' '+item.last_name}}</td>
                          <td>{{item.phone}}</td>
                          <td>{{item.email}}</td>
                          <td>{{(item.address_1 || item.address_2) ? item.address_1+', '+item.city+', '+item.state.name+', '+item.zip:''}}</td>
                          <td><a :href="'tel:'+item.phone"><i class="material-icons float-left" style="font-size: 40px;color:green;">
                    call
                  </i></a></td>
                          <td></td>
                      </tr>
                    </tbody>
                </table>
                </div>
               
              </div>
            </div>
            <template v-slot:modal-footer="{  }">
              <b-button size="sm" class="btn btn-save" variant="save" style="background-color: white; color: black;" @click="closeSelectModal">
                Close
              </b-button>
            </template>
          </b-modal>

          <!-- Activities and Notes Modal -->
          <ActivityAndNotesModal ref="activitiesModal" :jobId="$route.params.id" />
          <BidInvoiceJobModal ref="bidInvoiceModal" :jobId="$route.params.id" />
    </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import ActivityAndNotesModal from './ActivityAndNotesModal.vue'
import BidInvoiceJobModal from './BidInvoiceJobModal.vue'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components : {Loading,Datetime,VueBootstrapTypeahead,ActivityAndNotesModal,BidInvoiceJobModal},
  data() {
    return {
      constants: CommonConstants,
      isLoading: true,
      jobData : [],
      account_options : [],
      job_option : [],
      status_options : [{value: "request", text: 'Request'}, {value: 'outstanding', text: 'Outstanding'},
          {value: 'contracted', text: 'Contracted'}, {value: 'proceed', text: 'Proceed'}
          , {value: 'scheduled', text: 'Scheduled'}, {value: 'completed', text: 'Completed'},
          {value: 'invoicing', text: 'Invoicing'}, {value: 'paid', text: 'Paid'}, {
            value: 'rejected',
            text: 'Rejected'
          }],
      contactStates: ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL', 'GA','HI','ID','IL','IN','IA','KS','KY','LA', 'ME','MD','MA','MI', 'MN', 'MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI', 'SC', 'SD','TN', 'TX', 'UT', 'VT', 'VA','WA', 'WV','WI','WY'
        ],
      progressionOptions:[
          { value: 'active',text : 'Active' },
          { value: 'inactive',text : 'Inactive' },
          { value: 'inprogress',text : 'In Progress' },
          { value: 'hold',text : 'Hold' },
      ],
      job_contacts_dropdown : [],
      estimator_options : [],
      project_manager_options : [],
      foreman_options : [],
      contacts:[],
      accountant_options : [],
      sales_person_options : [],
      lead_source_options : [],
      custom_drop_options_1 : [],
      custom_drop_options_2 : [],
      custom_drop_options_3 : [],
      custom_drop_options_4 : [],
      custom_drop_options_5 : [],
      custom_drop_options_6 : [],
      isPrevailingWage:false,
      prevailingWages:[],
      bid_type_options : [],
      bid_stage_options : [],
      progression_flag: false,
      selectAll: false,
      progressionFieldOptions: [],
      progressionDef: {},
      customDropdown1 : '',
      customDropdown2 : '',
      customDropdown3 : '',
      customDropdown4 : '',
      customDropdown5 : '',
      customDropdown6 : '',
      customField1 : '',
      customField2 : '',
      customField3 : '',
      customField4 : '',
      customField5 : '',
      customField6 : '',
      progressionValuesData : [],
      previousUrl : localStorage.getItem('previous_url') ? localStorage.getItem('previous_url') : 'jobs'

    }
  },
   mounted (){
     let self = this;
    this.getFormData();
    this.job_option = JSON.parse(localStorage.getItem('jobs_status_json'));
    // setTimeout(function() {
    //   self.loadDTPAST();
    // }, 1000);
  },
  methods : {
    getFormData (){
      let self = this;
      let header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
      axios.post(this.constants.api_url + 'job/view/' + this.$route.params.id, {"fromImport": 1},header)
      .then(function (response) {
        if (response.data.flag) {
          console.log(response.data);
          self.jobData = response.data.data.job
          self.contacts = response.data.data.contacts;
          self.account_options = response.data.data.accounts_dropdowns
          self.jobData.account = self.jobData.account ? self.jobData.account.toString() : '';
          self.jobData.completed_date =  moment(self.jobData.completed_date).format('YYYY-MM-DD');
          self.jobData.estimator = response.data.data.job.estimator.id ? response.data.data.job.estimator.id : ''
          self.$refs.account.inputValue = response.data.data.account_name;
          self.jobData.project_manager = response.data.data.job.project_manager.id ? response.data.data.job.project_manager.id : '';
          self.jobData.accounting = response.data.data.job.accounting.id
          self.jobData.foreman = response.data.data.job.foreman.id ? response.data.data.job.foreman.id : '';
          self.jobData.salesman = response.data.data.job.salesman ? response.data.data.job.salesman.id : '';
          self.job_contacts_dropdown = response.data.data.job_contacts_dropdown;
          self.$refs.contact.inputValue = response.data.data.job.primary_contact ? response.data.data.job.primary_contact.value : '';
          self.isPrevailingWage = response.data.data.is_prevailing_wage;
          self.prevailingWages = response.data.data.prevailing_wage_survey;
          // self.jobData.primary_contact = response.data.data.job.primary_contact ? response.data.data.job.primary_contact.id.toString() : '';
          if(response.data.data.job.primary_contact){
            if(response.data.data.job.primary_contact.id)
              response.data.data.job.primary_contact.id.toString();
            else
              self.jobData.primary_contact = '';
          }else{
            self.jobData.primary_contact = '';
          }
          self.estimator_options = response.data.data.estimators;
          self.project_manager_options = response.data.data.project_managers
          self.foreman_options = response.data.data.foremen
          self.sales_person_options = response.data.data.salesman
          self.accountant_options = response.data.data.accountants
          self.lead_source_options = response.data.data.lead_sources
          let d = response.data.data;
          self.customField1 = response.data.data.company.custom_text_1;
          self.customField2 = response.data.data.company.custom_text_2;
          self.customField3 = response.data.data.company.custom_text_3;
          self.customField4 = response.data.data.company.custom_text_4;
          self.customField5 = response.data.data.company.custom_text_5;
          self.customField6 = response.data.data.company.custom_text_6;
          self.customDropdown1 = (typeof d.custom_fields_dropdowns[0] != 'undefined') ? d.custom_fields_dropdowns[0].drop_key : '';
          self.customDropdown2 = (typeof d.custom_fields_dropdowns[1] != 'undefined') ? d.custom_fields_dropdowns[1].drop_key : '';
          self.customDropdown3 = (typeof d.custom_fields_dropdowns[2] != 'undefined') ? d.custom_fields_dropdowns[2].drop_key : '';
          self.customDropdown4 = (typeof d.custom_fields_dropdowns[3] != 'undefined') ? d.custom_fields_dropdowns[3].drop_key : '';
          self.customDropdown5 = (typeof d.custom_fields_dropdowns[4] != 'undefined') ? d.custom_fields_dropdowns[4].drop_key : '';
          self.customDropdown6 = (typeof d.custom_fields_dropdowns[5] != 'undefined') ? d.custom_fields_dropdowns[5].drop_key : '';



          let industrySegments = (typeof d.custom_fields_dropdowns[0] != 'undefined')? d.custom_fields_dropdowns[0].drop_value : '';
            self.custom_drop_options_1 = industrySegments
          let bids = (typeof d.custom_fields_dropdowns[1] != 'undefined')? d.custom_fields_dropdowns[1].drop_value : '';
          self.custom_drop_options_2 = bids
          let pictures = (typeof d.custom_fields_dropdowns[2] != 'undefined') ? d.custom_fields_dropdowns[2].drop_value : '';
          self.custom_drop_options_3 = pictures
          let customField4Option = (typeof d.custom_fields_dropdowns[3] != 'undefined') ? d.custom_fields_dropdowns[3].drop_value : '';
          self.custom_drop_options_4 = customField4Option
          let customField5Option = (typeof d.custom_fields_dropdowns[4] != 'undefined') ? d.custom_fields_dropdowns[4].drop_value : '';
          self.custom_drop_options_5 = customField5Option
          let customField6Option = (typeof d.custom_fields_dropdowns[5] != 'undefined') ? d.custom_fields_dropdowns[5].drop_value : '';
          self.custom_drop_options_6 = customField6Option
          self.progressionValuesData = d.progression_values;

          // Set bid tracker options
          self.bid_type_options = d.bid_types || [];
          self.bid_stage_options = d.bid_stages || [];

          // Set progression field options
          self.progressionFieldOptions = d.progression_drop || [];

          // Build progression definition lookup
          if (d.progression_def) {
            d.progression_def.forEach(val => {
              self.progressionDef[val.id] = {
                unit: val.unit,
                decimal: val.decimal_place,
                type: val.type
              };
            });
          }

          // Check progression status to show/hide production tracker
          self.checkStatus();

          console.log(self.jobData);
          self.isLoading = false;

        }
      })
    },
    loadDTPAST (){
      var self = this;
      // self.isLoading = true;
      $("#past_table").DataTable({
        // processing: true,
        //serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1
            }
        },
        "ordering": true,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        ],
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   true,
        destroy: true,
        orderClasses: false,
        // "initComplete": function( settings, json ) {
        //     self.isLoading = false;
        //   },
        language: {
          emptyTable: "There is no Contacts available.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          oPaginate: {
            sNext: '<i class="fas fa-angle-double-right"></i>',
            sPrevious: '<i class="fas fa-angle-double-left"></i>'
          },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        // data: self.contacts,
        // columns: [
          // {
          //   render: function(data, type, full, meta) {
          //     return (
          //       '<router-link to="/add"><a href="/timesheets/view/'+full.id+'">' + full.period_start +' - '+ full.period_end +'</a></router-link>'
          //     );
          //   }

          // },
          // {
          //   title: "Created On",
          //   render: function(data, type, full, meta) {
          //     return moment(full.created_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');

          //   }
          // },
          // {
          //   title: "Last Update",
          //   render: function(data, type, full, meta) {
          //     return moment(full.updated_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');
          //   }
          // },
          // { data: "totalTime" },
          // { data: "created_by_name" },
          // {
          //   render: function(data, type, full, meta) {
          //     return (
          //       ''
          //     );
          //   }
          // }
        // ]
      });

      $("#past_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    selectedAccount (query){
      let self = this;
      self.jobData.account = query.id.toString()
    },
    selectedContact (query){
      let self = this;
      self.jobData.primary_contact = query.id.toString()
    },
    validator(validate) {
        return validate === '' || validate === null
    },
    getAddressMapData(){
        let self = this

        let address = self.jobData.site_address_1 + ", "+self.jobData.site_address_2 + ", "+self.jobData.site_city + ", "+self.jobData.site_state + ", "+self.jobData.site_zip
        if (self.jobData.site_address_1 != '' || self.jobData.site_address_2 != '') {
          let geocoder = new google.maps.Geocoder();
          let latitude = ''
          let longitude = ''
          geocoder.geocode({'address': address}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              latitude = results[0].geometry.location.lat();
              longitude = results[0].geometry.location.lng();
              if (longitude && latitude) {
                self.jobData.site_longitude = longitude.toString()
                self.jobData.site_latitude = latitude.toString()
                self.editFinal()
                
              } else {
                self.editFinal()
              }
            } else {
              if (confirm("Entered site address is not valid, Are you sure you want to save?")) {
                self.jobData.site_longitude = '';
                self.jobData.site_latitude = '';
                self.editFinal()
              }
            }
          });
        } else {
          
              self.editFinal()
        }
      },
    selectContactModal(){
      let self = this;
      this.$refs['my-modal-select'].show();
      setTimeout(function() {
      self.loadDTPAST();
    }, 100);
    },
    closeSelectModal(){
      this.$refs['my-modal-select'].hide();
    },
    updateJob(){
      let self = this;
      let submitSuccess = true;
      let account_option_status = false;
      let contact_option_status = false;
      if (this.validator(this.jobData.name)) {
           Vue.$toast.error('Enter Job Name', {
                position: 'top'
            });
          submitSuccess = false
      } else if (this.validator(this.jobData.job_number)) {
        Vue.$toast.error('Enter Job Number', {
                position: 'top'
            });
        submitSuccess = false
      }else if (this.validator(this.jobData.account)) {
        Vue.$toast.error('Enter Account', {
                position: 'top'
            });
        submitSuccess = false
      }else if (this.validator(this.jobData.primary_contact) || this.jobData.primary_contact == 0) {
        Vue.$toast.error('Enter Primary Contact', {
                position: 'top'
            });
        submitSuccess = false
      } else if (this.validator(this.jobData.bid_date)) {
        Vue.$toast.error('Enter Bid Date', {
                position: 'top'
            });
        submitSuccess = false
      } else if (this.validator(this.jobData.status)) {
        Vue.$toast.error('Select Current Status', {
                position: 'top'
            });
        submitSuccess = false
      } else if (this.validator(this.jobData.accounting)) {
        Vue.$toast.error('Select Accountant', {
                position: 'top'
            });
        submitSuccess = false
      } else if (this.validator(this.jobData.estimator)) {
        Vue.$toast.error('Select Estimator', {
                position: 'top'
            });
        submitSuccess = false
      } else if (this.validator(this.jobData.project_manager)) {
        Vue.$toast.error('Select Project Manager', {
                position: 'top'
            });
        submitSuccess = false
      } else if (this.validator(this.jobData.foreman)) {
        Vue.$toast.error('Select Foreman', {
                position: 'top'
            });
        submitSuccess = false
      } else if (this.validator(this.jobData.progress_status)) {
        Vue.$toast.error('Select Progress Status', {
                position: 'top'
            });
        submitSuccess = false
      } else {
        submitSuccess = true
      }
      for (var account of  self.account_options) {
        if (account.id == self.jobData.account) {
          account_option_status = true
          break
        }
      }
      if(self.job_contacts_dropdown != ''){

        for (var contact of  self.job_contacts_dropdown) {
          if (contact.id == self.jobData.primary_contact || (self.jobData.primary_contact.id && contact.id == self.jobData.primary_contact.id)) {
            contact_option_status = true
            break
          }
        }
      }
      if(account_option_status == false && submitSuccess ==true){
        submitSuccess = false
        Vue.$toast.error('Invalid Account seleted', {
                position: 'top'
            });
      }
      if(this.job_contacts_dropdown !='' && contact_option_status == false && submitSuccess ==true){
        submitSuccess = false
        Vue.$toast.error('Invalid Primary Contact seleted', {
                position: 'top'
            });
      }
      if(submitSuccess){
        this.getAddressMapData();
      }
      
    },
    editFinal() {
        //this.updateJob()
        let self = this;
        console.log(self.jobData);
        
        if (self.isPrevailingWage && ['contracted', 'proceed', 'scheduled', 'completed', 'invoicing', 'paid'].includes(self.jobData.status) && (!self.jobData.prevailing_wage || self.jobData.prevailing_wage == '' || self.jobData.prevailing_wage == null)) {
            alert("You need to select a Prevailing Wage Survey if you are changing the status to Contracted, Proceed, Scheduled, Completed, Invoicing or Paid.");
            return true;
        }else{
        self.isLoading = true;
        let data = {
          'progressionData' : self.progressionValuesData,
          'removeProgressionData' : [],
          "job_contacts": "",
          "bid_date": this.jobData.bid_date? moment(this.jobData.bid_date).format('MM/DD/YYYY'): null,
          "estimator_deadline":this.jobData.estimator_deadline? moment(this.jobData.estimator_deadline).format('MM/DD/YYYY'): null,
          "estimator_priority":this.jobData.estimator_priority,
          "production_deadline":this.jobData.production_deadline? moment(this.jobData.production_deadline).format('MM/DD/YYYY'): null,
          "production_priority": this.jobData.production_priority,
          "completed_date": this.jobData.completed_date? moment(this.jobData.completed_date).format('MM/DD/YYYY'): null,
          "fromImport": "0",
          "name": this.jobData.name,
          "job_number": this.jobData.job_number,
          "assigned_job_account": this.jobData.account,
          "new_account_name": "",
          "primary_contact": this.jobData.primary_contact.id ? this.jobData.primary_contact.id : this.jobData.primary_contact,
          "status": this.jobData.status,
          "progress_status": this.jobData.progress_status ? this.jobData.progress_status : this.jobData.progress_status,
          "estimator": this.jobData.estimator,
          "project_manager": this.jobData.project_manager,
          "foreman": this.jobData.foreman,
          "accounting": this.jobData.accounting,
          "salesman" : this.jobData.salesman ? this.jobData.salesman : '',
          "prime_contract": this.jobData.prime_contract,
          "bid_status": this.jobData.bid_status ? this.jobData.bid_status : 0,
          "bid_type": this.jobData.bid_type ? this.jobData.bid_type : '',
          "bid_stage": this.jobData.bid_stage ? this.jobData.bid_stage : '',
          "bid_notes": this.jobData.bid_notes ? this.jobData.bid_notes : '',
          "site_address_1": this.jobData.site_address_1,
          "site_address_2": this.jobData.site_address_2,
          "site_city": this.jobData.site_city,
          "site_state": this.jobData.site_state,
          "site_zip": this.jobData.site_zip,
          "siteLongitude" : this.jobData.site_longitude,
          "siteLatitude" : this.jobData.site_latitude,
          "billing_address_1": this.jobData.billing_address_1,
          "billing_address_2": this.jobData.billing_address_2,
          "billing_city": this.jobData.billing_city,
          "billing_state": this.jobData.billing_state,
          "billing_zip": this.jobData.billing_zip,
          "custom_text_1": this.jobData.custom_text_1,
          "custom_text_2": this.jobData.custom_text_2,
          "custom_text_3": this.jobData.custom_text_3,
          "custom_text_4": this.jobData.custom_text_4,
          "custom_text_5": this.jobData.custom_text_5,
          "custom_text_6": this.jobData.custom_text_6,
          "prevailing_wage": this.jobData.prevailing_wage,
          "is_pwa" : true

        }

        data.lead_source = this.jobData.lead_source && (this.jobData.lead_source != null) && (this.jobData.lead_source != '') ? this.jobData.lead_source : '';
        data.custom_drop_1 = this.jobData.custom_drop_1 && (this.jobData.custom_drop_1 != null) && (this.jobData.custom_drop_1 != '') ? this.jobData.custom_drop_1 : '';
        data.custom_drop_2 = this.jobData.custom_drop_2 && (this.jobData.custom_drop_2 != null) && (this.jobData.custom_drop_2 != '') ? this.jobData.custom_drop_2 : '';
        data.custom_drop_3 = this.jobData.custom_drop_3 && (this.jobData.custom_drop_3 != null) && (this.jobData.custom_drop_3 != '') ? this.jobData.custom_drop_3 : '';
        data.custom_drop_4 = this.jobData.custom_drop_4 && (this.jobData.custom_drop_4 != null) && (this.jobData.custom_drop_4 != '') ? this.jobData.custom_drop_4 : '';
        data.custom_drop_5 = this.jobData.custom_drop_5 && (this.jobData.custom_drop_5 != null) && (this.jobData.custom_drop_5 != '') ? this.jobData.custom_drop_5 : '';
        data.custom_drop_6 = this.jobData.custom_drop_6 && (this.jobData.custom_drop_6 != null) && (this.jobData.custom_drop_6 != '') ? this.jobData.custom_drop_6 : '';

        axios.post(this.constants.api_url + 'job/update/' + this.$route.params.id, data, {headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }})
          .then(function (response) {
            if (response.data.flag) {
              console.log(response.data);
              self.getFormData()
              Vue.$toast.success("Job updated successfully", {
                position: 'top'
              });

            } else {
              Vue.$toast.error(response.data.message, {
                position: 'top'
              });
            }
          })
          .catch(function (error) {
            Vue.$toast.error(error, {
                position: 'top'
            });
          })
        }
      },
    viewOnPage(){
      // Navigate to the web version's edit job page
      const webUrl = window.location.origin.replace('pwa.', '');
      const jobId = this.$route.params.id;
      const fullUrl = `${webUrl}/job/${jobId}`;
      window.open(fullUrl, '_blank');
    },
    showActivitiesModal() {
      // Show the activities and notes modal
      this.$refs.activitiesModal.show();
    },
    openBidInvoiceModal() {
      this.$refs.bidInvoiceModal.show();
    },
    openInMaps(flag) {
      if (flag === 'site') {
        let address1 = this.jobData.site_address_1 ? this.jobData.site_address_1 + ', ' : '';
        let address2 = this.jobData.site_address_2 ? this.jobData.site_address_2 + ', ' : '';
        let city = this.jobData.site_city ? this.jobData.site_city + ', ' : '';
        let state = this.jobData.site_state ? this.jobData.site_state + ', ' : '';
        let zip = this.jobData.site_zip ? this.jobData.site_zip : '';

        let address = address1 + address2 + city + state + zip;

        if (address.trim()) {
          window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`);
        } else {
          Vue.$toast.error('Enter a valid site address', {
            position: 'top'
          });
        }
      } else if (flag === 'billing') {
        let baddress1 = this.jobData.billing_address_1 ? this.jobData.billing_address_1 + ', ' : '';
        let baddress2 = this.jobData.billing_address_2 ? this.jobData.billing_address_2 + ', ' : '';
        let bcity = this.jobData.billing_city ? this.jobData.billing_city + ', ' : '';
        let bstate = this.jobData.billing_state ? this.jobData.billing_state + ', ' : '';
        let bzip = this.jobData.billing_zip ? this.jobData.billing_zip : '';

        let baddress = baddress1 + baddress2 + bcity + bstate + bzip;

        if (baddress.trim()) {
          window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(baddress)}`);
        } else {
          Vue.$toast.error('Enter a valid billing address', {
            position: 'top'
          });
        }
      } else {
        Vue.$toast.error('Address not available', {
          position: 'top'
        });
      }
    },
    checkStatus() {
      const progress_status = this.jobData.progress_status ? this.jobData.progress_status : '';
      if (progress_status === 'active' || progress_status === 'hold' || progress_status === 'inprogress') {
        this.progression_flag = true;
      } else {
        this.progression_flag = false;
      }
    },
    addSelectedRow() {
      var temp = {
        discipline: '',
        unit: '',
        quantity: null,
        id: 'temp'.concat(Math.random()),
        selected: false
      };
      this.progressionValuesData.push(temp);
    },
    deleteSelectedRow() {
      this.progressionValuesData = this.progressionValuesData.filter(row => !row.selected);
      this.selectAll = false;
    },
    selectAllRows() {
      this.progressionValuesData.forEach(row => {
        row.selected = this.selectAll;
      });
    },
    onDisciplineChange(row) {
      if (row.discipline && this.progressionDef[row.discipline]) {
        row.unit = this.progressionDef[row.discipline].unit;
      } else {
        row.unit = '';
      }
    }
  }
}
</script>

<style>

</style>
